import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import about1 from "../../assets/service/about1.webp";
import about2 from "../../assets/service/about2.webp";
import { Helmet } from "react-helmet";
import "./about.css";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const About = () => {
    return (
        <>
            <Helmet>
                <title>
                    Replace Spreadsheets & Paper with Smart HRMS Software | TechCognics
                </title>

                <meta
                    name="description"
                    content="Eliminate manual HR processes using spreadsheets, emails, and paper. Switch to TechCognics intelligent HRMS software for automated payroll, attendance, and employee management."
                />

                <meta
                    name="keywords"
                    content="HR automation software, replace HR spreadsheets, digital HR management, HRMS system, paperless HR software, cloud HR software, automated payroll system"
                />

                <meta
                    property="og:title"
                    content="Replace Spreadsheets & Paper with Smart HRMS Software"
                />

                <meta
                    property="og:description"
                    content="Move away from spreadsheets and paper-based HR. Automate payroll, attendance, compliance, and employee management with a cloud-based HRMS."
                />

                <meta property="og:type" content="website" />
            </Helmet>
            <div className="about__one section-padding">
                <div className="container">
                    <div className="row  flex-wrap-reverse gy-4 spredSheetMngtTabView">
                        <div className="col-xl-6 col-lg-5 col-md-12">
                            <div className="about__one-image">
                                <div className="experience-bar animate-y-axis-slider">
                                    {/* <i class="flaticon-consultant"></i> */}
                                    <i class="bi bi-diagram-3"></i>

                                    <div className="experience-bar-right">
                                        <div className="experience-bar-counter">
                                            <h4 class="counter">10</h4>
                                            <span>+</span>
                                        </div>
                                        <span>Years Experience</span>
                                    </div>
                                </div>
                                <div className="about__one-image-wrapper">
                                    <img alt="about1" src={about1} className="image-1" />
                                    <img alt="about2" src={about2} className="image-2" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-7 col-md-12 " style={{ marginTop: '0px !important' }}>
                            <div className="about__one-content">
                                {/* <span className="subtitle-one">About us</span> */}
                                <div className="text-start feature-heading" style={{ color: '#0F4F93' }}>Still managing HRMS on Spreadsheets, Emails, and Paper ?</div>
                                <div className="about__one-content-service text-start">
                                    <div className="service">
                                        <CheckCircleOutlineIcon className="service-icon" />
                                        <span className="service-text">
                                            Payroll errors causing employee dissatisfaction
                                        </span>
                                    </div>

                                    <div className="service">
                                        <CheckCircleOutlineIcon className="service-icon" />
                                        <span className="service-text">
                                            Time lost tracking attendance and payroll manually
                                        </span>
                                    </div>

                                    <div className="service">
                                        <CheckCircleOutlineIcon className="service-icon" />
                                        <span className="service-text">
                                            Disconnected employee management processes
                                        </span>
                                    </div>

                                    <div className="service">
                                        <CheckCircleOutlineIcon className="service-icon" />
                                        <span className="service-text">
                                            Compliance risks due to inaccurate HR data
                                        </span>
                                    </div>

                                    <div className="service">
                                        <CheckCircleOutlineIcon className="service-icon" />
                                        <span className="service-text">
                                            No real-time visibility into workforce performance
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>


    );
};

export default About;
